import { useQuery } from '@tanstack/react-query';
import { useTacticHooks } from '../providers/TacticHooksProvider';

export const useOfficesQuery = () => {
  const { apiClient } = useTacticHooks();
  return useQuery({
    queryKey: ['useOfficesQuery', apiClient.slug],

    queryFn: async () => {
      const res = await apiClient.organizations.offices();
      return res.result;
    },

    staleTime: 5000 * 60,
    enabled: !!apiClient.slug
  });
};
